export default {
  typeOptions: {
    NP: 'Pessoa física',
    LP: 'Pessoa jurídica'
  },
  NP: {
    type: 'Personalidade jurídica',
    residence: 'Tipo de residência',
    name: 'Nome',
    tradeName: 'Primeiro Sobrenome',
    lastName: 'Segundo Sobrenome',
    document: 'CNPJ',
    street: 'Endereço',
    postalCode: 'CEP',
    town: 'Cidade',
    city: 'Estado',
    country: 'País',
    accountingOffice: 'Escritório Contábil',
    Dir3Data: {
      code: 'Código',
      description: 'Descrição',
      postalCode: 'CEP',
      address: 'Endereço',
      city: 'Cidade',
      region: 'Estado',
      country: 'País',
      name: 'Nome',
      firstName: 'Primeiro Sobrenome',
      lastName: 'Segundo Sobrenome'
    },
    managerBody: 'Código órgão gestor',
    processingUnit: 'Unidade processadora',
    proponentBody: 'Órgão proponente',
    contactMedium: 'Dados de contato',
    additionalInfo: 'Informações adicionais solicitadas pelo pagador',
    contractReference: 'Referência do contrato',
    mercantileRegistry: 'Registro Comercial'
  },
  LP: {
    type: 'Personalidade jurídica',
    residence: 'Tipo de residência',
    name: 'Razão social',
    tradeName: 'Nome fantasia',
    lastName: 'Segundo Sobrenome',
    document: 'CNPJ',
    street: 'Endereço',
    postalCode: 'CEP',
    town: 'Cidade',
    city: 'Estado',
    country: 'País',
    accountingOffice: 'Escritório Contábil',
    managerBody: 'Código órgão gestor',
    processingUnit: 'Unidade processadora',
    proponentBody: 'Órgão proponente',
    contactMedium: 'Dados de contato',
    additionalInfo: 'Informações adicionais solicitadas pelo pagador',
    contractReference: 'Referência do contrato',
    mercantileRegistry: 'Registro Comercial',
    FACeB2B: {
      sectionTitle: 'Dados FACeB2B',
      code: 'Código do receptor',
      name: 'Nome',
      publicOrganismCode: 'Órgão gestor',
      contractReference: 'Referência do contrato'
    }
  },
  FC: {
    residence: 'Tipo de residência',
    corporateName: 'Razão social',
    tradeName: 'Nome fantasia',
    document: 'CNPJ',
    address: 'Endereço',
    street: 'Rua',
    postalCode: 'CEP',
    town: 'Cidade',
    city: 'Estado',
    country: 'País',
    book: 'Livro',
    folio: 'Fólio',
    sheet: 'Folha',
    section: 'Seção',
    volume: 'Volume',
    mercantileRegistry: 'Registro Comercial',
    additionalRegistrationData: 'Informações adicionais',
    medium: 'Informações adicionais',
    email: 'Email',
    fax: 'Fax',
    phone: 'Telefone',
    web: 'Endereço web',
    name: 'Pessoa de contato',
    additionalContactDetails: 'Informações adicionais'
  },
  riojaAgendaMessage: 'Recomenda-se adicionar o contato a partir da agenda e realizando a busca pelo Órgão gestor, em vez de adicioná-lo manualmente'
}